<template>
  <div style="width: 100%;min-height: 90vh" class="bgff" v-loading="showLoading">
    <!--分类-->
    <div class="tabs dif alc">
      <div class="tab_item difcac hover" @click="changeTabs(index,item)"
           v-for="(item,index) in tabs" :key="index" :class="{'active': current===index}">{{item.name}}</div>
    </div>
    <!--订单-->
    <div class="order_list pl20 pr20" >
      <div style="padding-top: 100px;" v-if="list.length<=0">
        <el-result icon="info" title="暂无订单"></el-result>
      </div>
      <div v-for="(item,index) in list" class="apply_item" @click="goDetail(item)">
        <div class="difb alc">
          <div class="fs20 bold text_333 pointer">订单号：{{item.order_no}}</div>
          <div class="fz20" style="color: #E7A100" v-if="item.status_text==='审核中'">{{item.status_text}}</div>
          <div class="fz20" style="color: #04C631" v-if="item.status_text==='已通过'">{{item.status_text}}</div>
          <div class="fz20" style="color: #E70000" v-if="item.status_text==='已驳回'">{{item.status_text}}</div>
        </div>
        <div class=" difb" style="margin-top: 18px">
          <div class="pointer">
            <p class="fs18 col888">产品名称：{{item.product_name}}</p>
            <p class="fs18 col888" style="margin-top: 12px">提交申请日期：{{item.createtime_str}}</p>
          </div>
          <div class="dif pointer">
            <div class="difcc">
              <img src="@/assets/images/dui.png" v-if="item.audit_status>1 && (item.reject_status>1 || item.reject_status==0)" class="w-28 h-28 block" alt="">
              <img src="@/assets/images/sc.png" v-else-if="item.reject_status===1" class="w-28  h-28 block" alt="">
              <div class="small_radio difcac" v-else>1</div>
              <p class="mt8" :style="{color: item.audit_status>1 && (item.reject_status>1 || item.reject_status==0)?'#1572F9':item.reject_status===1?'#E70000':'#888888'}">信息部</p>
            </div>
            <div class="w-42 mt14" style="border-top: 1px solid #888"></div>
            <div class="difcc">
              <img src="@/assets/images/dui.png" v-if="item.audit_status>2 && (item.reject_status>2 || item.reject_status==0)" class="w-28 h-28 block" alt="">
              <img src="@/assets/images/sc.png" v-else-if="item.reject_status===2" class="w-28  h-28 block" alt="">
              <div class="small_radio difcac" v-else>2</div>
              <p class="mt8" :style="{color: item.audit_status>2 && (item.reject_status>2 || item.reject_status==0)?'#1572F9':item.reject_status===2?'#E70000':'#888888'}">财务部</p>
            </div>
            <div class="w-42 mt14" style="border-top: 1px solid #888"></div>
            <div class="difcc">
              <img src="@/assets/images/dui.png" v-if="item.audit_status>3 && (item.reject_status>3 || item.reject_status==0)" class="w-28 h-28 block" alt="">
              <img src="@/assets/images/sc.png" v-else-if="item.reject_status===3" class="w-28  h-28 block" alt="">
              <div class="small_radio difcac" v-else>3</div>
              <p class="mt8" :style="{color: item.audit_status>3 && (item.reject_status>3 || item.reject_status==0)?'#1572F9':item.reject_status===3?'#E70000':'#888888'}">总经理</p>
            </div>
            <div class="w-42 mt14 " style="border-top: 1px solid #888"></div>
            <div class="difcc">
              <img src="@/assets/images/dui.png" v-if="item.audit_status>4 && (item.reject_status>4 || item.reject_status==0)" class="w-28 h-28 block" alt="">
              <img src="@/assets/images/sc.png" v-else-if="item.reject_status===4" class="w-28  h-28 block" alt="">
              <div class="small_radio difcac" v-else>4</div>
              <p class="mt8" :style="{color: item.audit_status>4 && (item.reject_status>4 || item.reject_status==0)?'#1572F9':item.reject_status===4?'#E70000':'#888888'}">财务打款</p>
            </div>
          </div>
        </div>
        <!--操作-->
        <div class="dife mt20 alc" v-if="item.audit_status==6">
          <div class="s_button difcac" @click.stop="goSubmit(item)">重新提交</div>
        </div>
      </div>
    </div>
    <!--分页-->
    <div class="difcac home_page" style="margin: 38px 0 50px 0;">
      <el-pagination
          background
          layout="prev, pager, next"
          :page-count="allPage"
          :current-page="page"
          @current-change="changeSize">
      </el-pagination>
    </div>

    <!--申请-->
    <!--<img src="@/assets/images/sq.png" @click="goSubmit()" class="posf pointer popper__arrow block w-112 h-112" style="bottom: 55px;right: 50px;">-->
    <div class="submit difcac" @click="goSubmit()">申请提成</div>
    <!--支付方式选择-->
    <el-dialog
        title="选择支付方式"
        :visible.sync="showPay"
        width="40%"
        top="25vh">
      <div>
        <div class="difcac">
          <div class="pay_item difcac" @click="payType=1" :class="{'active': payType===1}">
            <img src="@/assets/images/icon_zhifubao.png" style="width: 38px;height: 38px;">
            <span class="mrLft10">支付宝支付</span>
            <div class="check" v-if="payType===1"></div>
            <i class="el-icon-check check_icon" v-if="payType===1"></i>
          </div>
          <div class="pay_item difcac mrLft20" @click="payType=2" :class="{'active': payType===2}">
            <img src="@/assets/images/icon_wieixin.png" style="width: 38px;height: 38px;">
            <span class="mrLft10">微信支付</span>
            <div class="check" v-if="payType===2"></div>
            <i class="el-icon-check check_icon" v-if="payType===2"></i>
          </div>
        </div>
        <div class="dife alc mrTop30">
          <el-button @click="showPay=false">取 消</el-button>
          <el-button type="primary" @click="pay()">支 付</el-button>
        </div>
      </div>
    </el-dialog>
    <!--支付宝支付-->
    <el-dialog :visible.sync="showAlipay" :modal="true" width="350px" :center="true" top="40vh" @close="close2()">
      <div class="difcc">
        <h2 class="tct mrBtm20">支付宝支付</h2>
        <div class="mrTop20 difcac">
          <div>
            <el-button type="success" plain round @click="paySuccess()">支付完成</el-button>
          </div>
          <div class="mrLft30">
            <el-button type="info" plain round @click="close2()">重新支付</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!--微信-->
    <el-dialog :visible.sync="showWeChatCode" :modal="true" width="350px" :center="true" top="30vh" @close="close()">
      <div v-if="imgUrl" class="difcc">
        <h2 class="tct mrBtm20">微信支付</h2>
        <img :src="imgUrl" style="width: 200px;height: auto">
        <div class="mrTop20 difcac">
          <div>
            <el-button type="success" plain round @click="paySuccess()">支付完成</el-button>
          </div>
          <div class="mrLft30">
            <el-button type="info" plain round @click="close()">重新支付</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "commissionList",
  data() {
    return {
      tabs: [
        {id: 999,name: '全部订单'},
        {id: 1,name: '审核中'},
        {id: 2,name: '已通过'},
        {id: 3,name: '已驳回'},
      ],
      current: 0,
      showLoading: false,
      page: 1,
      limit: 5,
      allPage: 1,//总页数
      list: [],//订单列表
      afterList: [],//售后订单列表

      setId: '',//当前选中的id

      showPay: false,
      payType: 1,//1支付宝支付 2微信支付
      showAlipay: false,
      showWeChatCode: false,
      imgUrl: '',//微信二维码
    }
  },
  methods: {
    //提交申请
    goSubmit(item) {
      let data = {}
      if(item) data.id = item.id
      let path = this.$router.resolve({
        path: '/me/myCommission/submit',
        query: data
      })
      window.open(path.href)
    },
    //订单详情
    goDetail(item) {
      let path = this.$router.resolve({
        path: '/me/myCommission/orderDetail',
        query: {
          id: item.id
        }
      })
      window.open(path.href)
    },
    //选择状态
    changeTabs(index,item) {
      this.current = index
      this.page = 1
      this.getOrderList()
    },
    //切换页数
    changeSize(e) {
      this.page = e
      this.getOrderList()
    },
    //获取订单列表
    getOrderList() {
      let data = {
        page: this.page,
        limit: this.limit,
        status: this.tabs[this.current].id
      }
      this.showLoading = true
      this.$axios("POST","/push_money/getList",data)
          .then(res => {
            this.showLoading = false
            if (res.code===1) {
              this.list = res.data.list
              this.allPage = Math.ceil(res.data.total/this.limit)
              console.log(Math.ceil(res.data.total/this.limit));
            }else {
              this.$message.error(res.msg)
            }
          })
    },
  },
  created() {
    this.getOrderList() //获取订单列表
  }
}
</script>

<style scoped>
.submit{
  position: fixed;
  z-index: 88;
  bottom: 50px;
  width: 200px;
  transform: translateX(460px);
  height: 42px;
  cursor: pointer;
  background: #1572F9;
  border-radius: 21px 21px 21px 21px;
  font-size: 20px;
  color: #FFF;
}
.s_button{
  width: 120px;
  height: 42px;
  cursor: pointer;
  background: #1572F9;
  border-radius: 21px 21px 21px 21px;
  font-size: 20px;
  color: #FFF;
}
.small_radio{
  width: 28px;
  height: 28px;
  font-size: 16px;
  box-sizing: border-box;
  border-radius: 50%;
  color: #888;
  border: 1px solid #707070;
}
.order_list{
  border-top: 1px solid #1572F9;
}
.apply_item{
  margin: 10px auto;
  width: 100%;
  box-sizing: border-box;
  background: #F7F6FA;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid rgba(112,112,112,0.1);
  padding: 20px 30px 18px 20px;
  box-sizing: border-box;
}
.order_item{
  padding: 16px 14px 19px 21px;
  border-bottom: 1px solid #1572F9;
}
.order_img{
  width: 106px;
  height: 106px;
  background-color: #EEEEEE;
  margin-right: 34px;
}
.tabs{
  height: 29px;
  background: #1572F9;
}
.tab_item{
  font-size: 14px;
  color: #ffffff;
  box-sizing: border-box;
  padding: 0 21px;
  cursor: pointer;
  height: 29px;
}
.tab_item.active{
  background-color: #3EA6FF;
}


.pay_item{
  width: 236px;
  height: 69px;
  background: #FFFFFF;
  border-radius: 6px 6px 6px 6px;
  border: 2px solid #868686;
  cursor: pointer;
  font-size: 28px;
  color: #383D42;
  overflow: hidden;
  position: relative;
}
.pay_item.active{
  border: 2px solid #337DF7;
  color: #337DF7;
}
.check{
  width: 41px;
  height: 41px;
  background-color: #3765FF;
  position: absolute;
  right: -20px;
  bottom: -20px;
  transform: rotate(45deg);
}
.check_icon{
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 18px;
  color: #ffffff;
  z-index: 22;
}
</style>
